import { TFunction } from 'i18next';
import { z } from 'zod';

export const getUserSchema = (t: TFunction) =>
  z.object({
    employeeId: z.string().nonempty(t('common.validation.fieldRequired')),
    fullName: z.string().nonempty(t('common.validation.fieldRequired')),
    roles: z.array(z.string()).optional(),
  });
